exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "advertise-management h2, advertise-management .ui-widget-header {\n  text-align: center;\n  margin: 5px 0px 10px 0px; }\n\nadvertise-management .ui-dialog-content.ui-widget-content i {\n  color: red; }\n\nadvertise-management .ad-option-section {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 60px; }\n\nadvertise-management .ad-option-margin {\n  margin: 0 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/advertise-management/advertise-management.component.scss
// module id = ../../../../../src/app/component-module/advertise-management/advertise-management.component.scss
// module chunks = main